import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { CategorieSocioPro } from '../models/options/categoriesSocioPro/categorieSocioPro'

const resource = 'CategoriesSocioPro'

export default class CategoriesSocioProResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifonly?: boolean) : Promise<PaginatedList<CategorieSocioPro>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (actifonly) params.append('ActifOnly', actifonly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }

  public async post(data : CategorieSocioPro) : Promise<CategorieSocioPro> {
    const response = await api.post(`${resource}`, data)
    return response.data
  }

  public async delete(id : string) : Promise<CategorieSocioPro> {
    const response = await api.delete(`${resource}/${id}`)
    return response.data
  }

  public async put(id : string, data : CategorieSocioPro) : Promise<CategorieSocioPro> {
    const response = await api.put(`${resource}/${id}`, data)
    return response.data
  }
}
